module.exports = __webpack_public_path__ + "img/store_w.cc1ab98c.svg";